<template>
  <div class="answer_sheet">
    <div class="answer_sheet_title">答题卡</div>
    <div class="answer_sheet_list">
      <div class="answer_sheet_one mt-30" v-for="(item, index) in answerSheetList.answerCard" :key="index">
        <div>{{ item.paperNumber }}</div>
        <div v-if="item.questionTypeId == 'choice'">
          <div v-for="(sitem, sindex) in item.questions" :key="sindex">
            <div class="choice_option flex Flexalign mt-20">
              <div class="mr-15">{{ sitem.number }}</div>
              <el-radio-group v-model="sitem.doAnswer[0]">
                <el-radio v-for="ssitem in sitem.itemNumber" :key="ssitem" :value="String(ssitem)"
                  :disabled="sitem.isCorrect.length">{{ getChoiceLabel(ssitem) }}</el-radio>
              </el-radio-group>
            </div>
            <div v-if="sitem.isCorrect.length" class="answer_box mt-10 px-20 flex FlexBetween Flexalign">
              <div>
                正确答案：<span class="text_active">{{sitem.answer[0]}}</span>
                <!-- 正确答案：<span class="text_active">{{
                  getChoiceLabel(sitem.answer[0])
                }}</span> -->
              </div>
              <div class="mar_left_20 flex">
                <div class="full_score">
                  <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                    v-if="sitem.isCorrect[0] == 2"></el-image>
                  <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                    v-if="sitem.isCorrect[0] == 1"></el-image>
                </div>
                <div class="get_score ml-10">
                  得分：{{ sitem.isCorrect[0] == 1 ? sitem.studentScore[0] : 0 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="item.questionTypeId == 'blank'">
          <div v-for="(sitem, sindex) in item.questions" :key="sindex">
            <div class="choice_option flex FlexStart mt-10" v-if="!sitem.isCorrect.length">
              <div class="mr-15 mt-20">{{ sitem.number }}</div>
              <div>
                <div class="blank_one flex Flexalign mt-15" v-for="ssitem in sitem.itemNumber" :key="ssitem">
                  <div class="mr-15">第{{ ssitem }}空</div>
                  <el-input v-model="sitem.doAnswer[ssitem - 1]" style="width: 350px" placeholder="请填写正确答案" />
                </div>
              </div>
            </div>
            <div v-if="sitem.isCorrect.length" class="answer_box py-10 mt-10 px-20">
              <div>{{ sitem.number }}、</div>
              <div class="flex FlexBetween">
                <div>答题结果</div>
                <div>总得分：{{ getTotalStudentScore(sitem.studentScore[0]) }}</div>
              </div>
              <div class="flex FlexBetween mt-20" style="line-height: 36px">
                <div>
                  <div>序号：</div>
                  <div v-for="ssitem in sitem.itemNumber" :key="ssitem">
                    <div>（{{ ssitem }}）</div>
                  </div>
                </div>
                <div>
                  <div>参考答案：</div>
                  <div v-for="ssitem in sitem.itemNumber" :key="ssitem">
                    <div>{{ sitem.answer[ssitem - 1] }}</div>
                  </div>
                </div>
                <div class="mar_left_20">
                  <div class="user_answer">
                    你的答案：
                    <div class="bg_line"></div>
                  </div>
                  <div v-for="ssitem in sitem.itemNumber" :key="ssitem">
                    <div>{{ sitem.doAnswer[ssitem - 1] }}</div>
                  </div>
                </div>
                <div class="mar_left_20">
                  <div>得分：</div>
                  <div class="flex Flexalign" v-for="ssitem in sitem.itemNumber" :key="ssitem">
                    <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                      v-if="sitem.isCorrect[ssitem - 1] == 2"></el-image>
                    <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                      v-if="sitem.isCorrect[ssitem - 1] == 1"></el-image>
                    <div class="get_score ml-10">
                      得分：{{ sitem.score[ssitem - 1] || 0 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="item.questionTypeId == 'judge'">
          <div v-for="(sitem, sindex) in item.questions" :key="sindex">
            <div class="choice_option flex Flexalign mt-20">
              <div class="mr-15">{{ sitem.number }}</div>
              <el-radio-group v-model="sitem.doAnswer[0]">
                <el-radio v-for="ssitem in 2" :key="ssitem" :value="ssitem" :disabled="sitem.isCorrect.length">{{
                  getJudgeLabel(ssitem) }}</el-radio>
              </el-radio-group>
            </div>
            <div v-if="sitem.isCorrect.length" class="answer_box mt-10 px-20 flex FlexBetween Flexalign">
              <div>
                正确答案：<span class="text_active">{{
                  getJudgeLabel(sitem.answer[0])
                }}</span>
              </div>
              <div class="mar_left_20 flex">
                <div class="full_score">
                  <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                    v-if="sitem.isCorrect[0] == 2"></el-image>
                  <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                    v-if="sitem.isCorrect[0] == 1"></el-image>
                </div>
                <div class="get_score ml-10">
                  得分：{{ sitem.isCorrect[0] == 1 ? sitem.studentScore[0] : 0 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="item.questionTypeId == 'answer'">
          <div class="choice_option flex FlexStart mt-20" v-for="(sitem, sindex) in item.questions" :key="sindex">
            <div class="mr-15">{{ sitem.number }}</div>
            <div v-if="!sitem.isCorrect.length">
              <quillEditor :model-value="sitem.doAnswer[0]"
                @update:model-value="(value) => getAnswer(value, index, sindex)"></quillEditor>
            </div>
            <div class="answer_box mt-10 py-10 px-20" v-if="sitem.isCorrect.length">
              <div class="flex FlexBetween">
                <div>答题结果</div>
                <div>得分：{{ sitem.studentScore[0] }}</div>
              </div>
              <div class="answer_top mt-10">
                <div>参考答案：</div>
                <div class="mt-10" v-html="$Tools.handlerImg(sitem.answer[0])" v-mathml></div>
              </div>
              <div class="answer_top mt-10">
                <div class="user_answer">
                  你的答案：
                  <div class="bg_line"></div>
                </div>
                <div class="mt-10" v-html="$Tools.handlerImg(sitem.doAnswer[0])" v-mathml></div>
              </div>
              <div class="answer_top mt-10" v-if="sitem.markerComment">
                <div class="user_answer">
                  老师批语：
                  <div class="bg_line bg_yellow_line"></div>
                </div>
                <div class="mt-10" v-html="$Tools.handlerImg(sitem.markerComment)" v-mathml></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="item.questionTypeId == 'composite'">
          <div class="choice_option flex FlexStart mt-20" v-for="(sitem, sindex) in item.questions" :key="sindex">
            <div class="mr-15">{{ sitem.number }}</div>
            <div style="width: 100%">
              <div class="sub_questions" v-for="(ssitem, ssindex) in sitem.subQuestions" :key="ssindex">
                <div class="mt-20" v-if="ssitem.questionTypeId == 'choice'">
                  <div class="flex Flexalign">
                    <div class="mr-15">
                      {{ ssitem.questionTypeName }}：（{{ ssitem.number }}）
                    </div>
                    <el-radio-group v-model="ssitem.doAnswer[0]">
                      <el-radio v-for="sssitem in ssitem.itemNumber" :key="sssitem" :value="sssitem"
                        :disabled="ssitem.isCorrect.length">{{ getChoiceLabel(sssitem) }}</el-radio>
                    </el-radio-group>
                  </div>
                  <div v-if="ssitem.isCorrect.length" class="answer_box mt-10 px-20 flex FlexBetween Flexalign">
                    <div>
                      正确答案：<span class="text_active">{{
                        getChoiceLabel(ssitem.answer[0])
                      }}</span>
                    </div>
                    <div class="mar_left_20 flex">
                      <div class="full_score">
                        <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                          v-if="ssitem.isCorrect[0] == 2"></el-image>
                        <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                          v-if="ssitem.isCorrect[0] == 1"></el-image>
                      </div>
                      <div class="get_score ml-10">
                        得分：{{ ssitem.isCorrect[0] == 1 ? ssitem.studentScore[0] : 0 }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-20" v-else-if="ssitem.questionTypeId == 'blank'">
                  <div class="flex FlexStart" v-if="!ssitem.isCorrect.length">
                    <div class="mr-15 mt-20">
                      {{ ssitem.questionTypeName }}：（{{ ssitem.number }}）
                    </div>
                    <div>
                      <div class="blank_one flex Flexalign mt-15" v-for="sssitem in ssitem.itemNumber" :key="sssitem">
                        <div class="mr-15">第{{ sssitem }}空</div>
                        <el-input v-model="ssitem.doAnswer[sssitem - 1]" style="width: 350px" placeholder="请填写正确答案" />
                      </div>
                    </div>
                  </div>
                  <div v-if="ssitem.isCorrect.length" class="answer_box py-10 mt-10 px-20">
                    <div>{{ ssitem.number }}、</div>
                    <div class="flex FlexBetween">
                      <div>答题结果</div>
                      <div>
                        总得分：{{ getTotalStudentScore(ssitem.studentScore[0]) }}
                      </div>
                    </div>
                    <div class="flex FlexBetween mt-20" style="line-height: 36px">
                      <div>
                        <div>序号：</div>
                        <div v-for="sssitem in ssitem.itemNumber" :key="sssitem">
                          <div>（{{ sssitem }}）</div>
                        </div>
                      </div>
                      <div>
                        <div>参考答案：</div>
                        <div v-for="sssitem in ssitem.itemNumber" :key="sssitem">
                          <div>{{ ssitem.answer[sssitem - 1] }}</div>
                        </div>
                      </div>
                      <div class="mar_left_20">
                        <div class="user_answer">
                          你的答案：
                          <div class="bg_line"></div>
                        </div>
                        <div v-for="sssitem in ssitem.itemNumber" :key="sssitem">
                          <div>{{ ssitem.doAnswer[sssitem - 1] }}</div>
                        </div>
                      </div>
                      <div class="mar_left_20">
                        <div>得分：</div>
                        <div class="flex Flexalign" v-for="sssitem in ssitem.itemNumber" :key="sssitem">
                          <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                            v-if="ssitem.isCorrect[sssitem - 1] == 2"></el-image>
                          <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                            v-if="ssitem.isCorrect[sssitem - 1] == 1"></el-image>
                          <div class="get_score ml-10">
                            得分：{{ ssitem.score[sssitem - 1] || 0 }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-20" v-else-if="ssitem.questionTypeId == 'judge'">
                  <div class="flex Flexalign">
                    <div class="mr-15">
                      {{ ssitem.questionTypeName }}：（{{ ssitem.number }}）
                    </div>
                    <el-radio-group v-model="ssitem.doAnswer[0]">
                      <el-radio v-for="sssitem in 2" :key="sssitem" :value="sssitem"
                        :disabled="ssitem.isCorrect.length">{{ getJudgeLabel(sssitem) }}</el-radio>
                    </el-radio-group>
                  </div>
                  <div v-if="ssitem.isCorrect.length" class="answer_box mt-10 px-20 flex FlexBetween Flexalign">
                    <div>
                      正确答案：<span class="text_active">{{
                        getJudgeLabel(ssitem.answer[0])
                      }}</span>
                    </div>
                    <div class="mar_left_20 flex">
                      <div class="full_score">
                        <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                          v-if="ssitem.isCorrect[0] == 2"></el-image>
                        <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                          v-if="ssitem.isCorrect[0] == 1"></el-image>
                      </div>
                      <div class="get_score ml-10">
                        得分：{{ ssitem.isCorrect[0] == 1 ? ssitem.studentScore[0] : 0 }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-20" v-else-if="ssitem.questionTypeId == 'answer'">
                  <div class="mr-15">
                    {{ ssitem.questionTypeName }}：（{{ ssitem.number }}）
                  </div>
                  <div v-if="!ssitem.isCorrect.length">
                    <quillEditor :model-value="ssitem.doAnswer[0]" @update:model-value="
                      (value) => getAnswer(value, index, sindex, ssindex)
                    "></quillEditor>
                  </div>
                  <div class="answer_box mt-10 py-10 px-20" v-if="ssitem.isCorrect.length">
                    <div class="flex FlexBetween">
                      <div>答题结果</div>
                      <div>得分：{{ ssitem.studentScore[0] }}</div>
                    </div>
                    <div class="answer_top mt-10">
                      <div>参考答案：</div>
                      <div class="mt-10" v-html="$Tools.handlerImg(ssitem.answer[0])" v-mathml></div>
                    </div>
                    <div class="answer_top mt-10">
                      <div class="user_answer">
                        你的答案：
                        <div class="bg_line"></div>
                      </div>
                      <div class="mt-10" v-html="$Tools.handlerImg(ssitem.doAnswer[0])" v-mathml></div>
                    </div>
                    <div class="answer_top mt-10" v-if="ssitem.markerComment">
                      <div class="user_answer">
                        老师批语：
                        <div class="bg_line bg_yellow_line"></div>
                      </div>
                      <div class="mt-10" v-html="$Tools.handlerImg(ssitem.markerComment)" v-mathml></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn_submit mt-40 cursor_pointer" @click="submit" v-if="!$Tools.empty(id)">
      提交作业
    </div>
  </div>
</template>

<script>
import quillEditor from "@/components/quillEditor/index.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5CustomAnswerSheet",
  props: {
    type: {},
    id: {},
    examInfo: {},
    homeworkInfo: {},
  },

  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
    }),
  },
  components: { quillEditor },

  data() {
    return {
      answerSheetList: [],
    };
  },

  mounted() {
    // 无id时，不调用接口，用作答记录的数据
    if (!this.$Tools.empty(this.id)) {
      this.getCustomAnswerSheet();
    } else {
      this.answerSheetList = this.homeworkInfo;
    }
  },

  methods: {
    getTotalStudentScore(studentScore) {
      let total = 0;
      total += Number(studentScore);
      return total;
    },
    // 富文本获取内容
    getAnswer(value, index, sindex, ssindex) {
      if (ssindex) {
        this.answerSheetList.answerCard[index].questions[sindex].subQuestions[
          ssindex
        ].doAnswer[0] = value;
      } else {
        this.answerSheetList.answerCard[index].questions[sindex].doAnswer[0] = value;
      }
    },
    // 获取自定义答题卡   // type为1课堂作业，2课后作业，type为1时id为examId，2为homeworkId
    getCustomAnswerSheet() {
      this.$Api.course
        .getCustomAnswerSheet(this.type, this.id)
        .then((res) => {
          this.answerSheetList = res.data.data;
        })
        .catch(() => { });
    },
    // 单选label
    getChoiceLabel(num) {
      let result = "";
      while (num > 0) {
        num--;
        result = String.fromCharCode(65 + (num % 26)) + result;
        num = Math.floor(num / 26);
      }
      return result;
    },
    // 判断label
    getJudgeLabel(index) {
      let arr = ["对", "错"];
      return arr[index - 1];
    },
    submit() {
      let listQuery = {};
      if (this.type == 1) {
        listQuery = {
          examId: this.examInfo.examId,
          examName: this.homeworkInfo.examName,
          examDetail: this.homeworkInfo.examDetail,
          assignmentContent: this.homeworkInfo.assignmentContent,
          assignmentFile: this.homeworkInfo.assignmentFile,
          assignmentContentAnswer: "",
          assignmentFileAnswer: [],
          answerCard: this.answerSheetList?.answerCard || [],
        };
      } else if (this.type == 2) {
        listQuery = {
          homeworkId: this.homeworkInfo.homeworkId,
          homeworkName: this.homeworkInfo.homeworkName,
          homeworkDescription: this.homeworkInfo.homeworkDescription,
          customHomeworkContent: this.homeworkInfo.assignmentContent,
          customHomeworkFile: this.homeworkInfo.assignmentFile,
          customHomeworkContentAnswer: "",
          customHomeworkFileAnswer: [],
          answerCard: this.answerSheetList?.answerCard || [],
        };
      }
      this.$Dialog.confirm({
        message: "作业提交前请细查细节，是否确认无误提交作业",
        title: "提示", // 可选，不传则使用默认值'确认'
        onConfirm: () => {
          if (this.type == 1) {
            this.$Api.exam
              .submitCustomizeHomework(listQuery)
              .then(() => {
                this.$Dialog.toast("提交成功,请等待老师的批阅");
                setTimeout(() => {
                  // this.$emit("goBack");
                  // 此处加入判断，判断提交后当前输入（作业）一步是否已完成，已完成则可以选择点击进入下一步
                  if (this.type == 1) {
                    this.$Api.course
                      .getMyCourseChapterProgress({
                        schemeChapterPhaseId: this.selectLearningInfo?.id,
                      })
                      .then((res) => {
                        if (res.data.data.outputStatus == 1) {
                          this.$Dialog.confirm({
                            message: "当前作业已全部完成，是否前往下一步",
                            title: "提示", // 可选，不传则使用默认值'确认'
                            onConfirm: () => {
                              this.$store.commit("learning/setStudyStepInfo", 2);
                            },
                            onCancel: () => {
                              this.$emit("goBack");
                            },
                          });
                        } else {
                          this.$emit("goBack");
                        }
                      })
                      .catch(() => { });
                  }
                }, 500);
              })
              .catch(() => { });
          } else if (this.type == 2) {
            this.$Api.exam
              .submitAfterCustomizeHomework(listQuery)
              .then(() => {
                this.$Dialog.toast("提交成功,请等待老师的批阅");
                setTimeout(() => {
                  this.$emit("goBack");
                  // 此处加入判断，判断提交后当前输入（作业）一步是否已完成，已完成则可以选择点击进入下一步
                }, 500);
              })
              .catch(() => { });
          }
        }, // 确认后的操作，如调用删除API等
        onCancel: () => { }, // 取消后的操作，可选不传则无动作。也可以在这里添加其他逻辑。
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.answer_sheet {
  .answer_sheet_title {
    font-size: 18px;
    color: #111111;
    text-align: center;
  }

  .btn_submit {
    margin: 40px auto;
    width: 160px;
    height: 48px;
    background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    border-radius: 30px;
    text-align: center;
    line-height: 48px;
    color: #ffffff;
  }

  .answer_box {
    width: 100%;
    min-height: 40px;
    background: #f8f9fa;
    border-radius: 8px;
    color: #909090;
    box-sizing: border-box;

    .question_error_icon {
      width: 26px;
      height: 26px;
    }

    .answer_top {
      .correct_value_answer {
        color: RGBA(0, 199, 88, 1);
      }

      .error_value_answer {
        color: RGBA(255, 49, 49, 1);
      }

      .btn_ask {
        width: 64px;
        height: 28px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 14px;
        line-height: 28px;
        text-align: center;
        color: #fff;
      }

      .get_score {
        color: #fd673b;
      }

      .user_answer {
        position: relative;

        .bg_line {
          width: 73px;
          height: 8px;
          background: rgba(19, 214, 170, 0.2);
          position: absolute;
          top: 16px;
          left: 0;
        }

        .bg_yellow_line {
          background: rgba(255, 145, 0, 0.2);
        }
      }
    }
  }
}
</style>
